import {Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, OnInit, Output, ViewEncapsulation} from "@angular/core";
import { FormControl, FormsModule } from "@angular/forms";
import { Store } from "@ngrx/store";
import { EventsWebsocketService } from "../../services/entities/events-websocket.service";
import {selectCameraTarget, selectCameraZoomTarget} from "src/app/state/camera/camera.selector";
import { entityActions } from "src/app/state/entities/entity.actions";
import {
  EntityType,
  Components,
  CollisionType,
} from "src/app/state/entities/entity.model";
import { Vector3 } from "three";
import { generateUUID } from "three/src/math/MathUtils.js";
import {config} from "rxjs";
import {MarkdownComponent} from "ngx-markdown";
import { MarkdownEditorModule } from '@mdefy/ngx-markdown-editor';
import {Editor, NgxEditorModule, Toolbar} from "ngx-editor";
import {FilesService} from "../../services/files/files.service";
import {Router} from "@angular/router";
import {selectFileUploadStatuss} from "../../state/interface/interface.selector";
import { selectUser } from "src/app/state/auth/auth.selector";
import {User} from "../../auth/primitives/user";
import {interfaceActions} from "../../state/interface/interface.actions";
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {NgIf} from "@angular/common";
import {FileUploadStatus} from "../../state/interface/dtos/file-upload-status.dto";
import {ImageProperties} from "../../state/entities/component-properties-dto/images.properties.dto";
import {faIcons} from "@fortawesome/free-solid-svg-icons/faIcons";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {IconsService} from "../../services/icons.service";

@Component({
  selector: "binsta-new-flyer",
  standalone: true,
  imports: [FormsModule, NgxEditorModule, Base64ImageComponent, NgIf, FaIconComponent],
  templateUrl: "./new-flyer.component.html",
  styleUrl: "./new-flyer.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class NewFlyerComponent implements OnInit {
  @Output()
  close = new EventEmitter();

  message: string = "";
  cameraTarget: Vector3 = new Vector3();

  editor!: Editor;
  html = '';

  toolbar: Toolbar = [
    ['bold', 'italic', "format_clear"],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    // ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  user: User
  userProfileImageBase64: string = null


  uploadStatuss: FileUploadStatus[] = [];
  uploadsCompleted: boolean[] = [];
  errorUploadsNotCompleted = false;

  allUploadsCompleted = true;

  constructor(
      private store: Store,
      private router: Router,
      private fileService: FilesService,
      private websocketService: EventsWebsocketService,
      public iconsService: IconsService,
  ) {
    this.store.select(selectCameraTarget).subscribe((target) => {
      this.cameraTarget.copy(target);
    });
    this.store.select(selectCameraZoomTarget).subscribe((target) => {
      // this.cameraZoom = target;
    });
    this.store
        .select(selectFileUploadStatuss)
        .subscribe((fileUploadStatuss) => {
          this.uploadStatuss = Object.values(fileUploadStatuss);
          this.uploadsCompleted = this.uploadStatuss.map((x) => x.completed);
          this.allUploadsCompleted = this.areAllUploadsCompleted();
        });
    this.store.select(selectUser)
        .subscribe(async (user) => {
          this.user = user
          const serverFile = await this.fileService.getFile(user.profile_image_file_id)
          this.userProfileImageBase64 = serverFile.fileData
        })
  }

  async ngOnInit(): Promise<void> {
    this.editor = new Editor();
  }


  areAllUploadsCompleted() {
    return this.uploadStatuss.reduce((prev, curr) => {
      return prev && curr.completed;
    }, true);
  }

  async filesSelected(files) {
    this.allUploadsCompleted = false;
    const proms = [];
    for (let file of files.target.files) {
      proms.push(this.uploadFile(file));
    }
    await Promise.allSettled(proms);
  }

  async uploadFile(file) {
    const fileIdToUpload = await this.fileService.getServerFileIdForNewFile(file);
    await this.fileService.uploadFile(fileIdToUpload, file);
  }

  removeImage(id: string) {
    this.store.dispatch(interfaceActions.clearFileUpload({
      fileId: id
    }))
  }


  closeHolder() {
    this.editor.destroy();
    this.store.dispatch(interfaceActions.clearFileUploads())
    this.html = "";
    this.router.navigate([{outlets: {'new-modal-pane': null}}])
  }

  post() {
    this.errorUploadsNotCompleted = false;
    if (!this.areAllUploadsCompleted()) {
      this.errorUploadsNotCompleted = true;
      return;
    }
    const imageProps: ImageProperties[] = this.uploadStatuss.map((upload) => {
      return {
        fileId: upload.id,
        description: `This is image: ${upload.id}`,
        userDefined: {
          tags: [],
          users: [],
        },
        inferred: {
          tags: [],
        },
      };
    });
    this.websocketService.dispatch(
        entityActions.netCreated({
          entity: {
            id: generateUUID(),
            type: EntityType.Gallery,
            ownerId: this.user.id,
            components: [Components.text, Components.images],
            coord: new Vector3(
                this.cameraTarget.x,
                this.cameraTarget.y,
                // this.cameraZoom - 700,
                Math.random() * 50,
            ),
            componentProperties: {
              Text: this.html,
              Images: imageProps,
              Reactions:  {
                smallScaleReactions: [],
                commonReactionsCounters: {},
              },
            },
            collisionType: CollisionType.Obstacle,
            creationDate: new Date(),
          },
        }),
    );
    this.html = "";
    this.close.emit(true);
  }

  protected readonly console = console;
  protected readonly config = config;
  protected readonly faIcons = faIcons;
}
